import store from '../../../store';

export default (to, from, next) => {
    if (store.getters['role'] == 2 || store.getters['role'] == 3 || store.getters['role'] == 1) {
        next();
    } else {
        next({ name: 'home' });
    }
}